import axios from "axios";
import {
    PATIENT_HOURS_REPORT, SET_ERROR, SYNC_PH, PHRS
} from "../../types";
import ToastMessage from '../../../components/toast'

export const patientHoursAction = (params) => {
    return async (dispatch) => {
        await axios.get('api/patient-hours/patient-hours-report', { params }).then(response => {
            dispatch({
                type: PATIENT_HOURS_REPORT,
                payload: response.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            });
        });
    };
};

export const SyncPHAction = (payload) => {
    return async (dispatch) => {
        await axios.post('api/patient-hours/sync-ph', payload).then(response => {
            dispatch({
                type: SYNC_PH,
                payload: response.data
            });
            ToastMessage("Payroll data successfully updated", "success");
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            });
            ToastMessage(e, "error");
        });
    };
};

export const getPHReportSettings = (companyId) => {

    return async dispatch => {
        await axios.get(`api/patient-hours/patient-hours-report-settings/${companyId}`).then(response => {
            if (!response.data?.comparisonColumns?.length) {
                response.data.comparisonColumns = [
                    {
                        key: "STRAIGHT_COMPARISON",
                        label: "Straight Comparison",
                        isActive: false
                    },
                    {
                        key: "REGULAR_PAY_ONLY",
                        label: "Regular pay only",
                        isActive: false
                    },
                    {
                        key: "COMBINED_METHOD",
                        label: "Combined Method",
                        isActive: false
                    }
                ];
            };
            dispatch({
                type: PHRS,
                payload: response.data
            });

        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            });
        });
    };
}

export const savePHReportSettings = payload => {
    return async dispatch => {
        await axios.post('api/patient-hours/patient-hours-report-settings', payload).then(res => {
            dispatch({
                type: PHRS,
                payload: res.data
            });
            ToastMessage("Successfully updated", "success");
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            });
        });
    };
};

